import { configureStore } from '@reduxjs/toolkit';
import authReducer from "./slices/authSlice";
import usersReducer from './slices/usersSlice';
import organizationReducer from './slices/organizationSlice';
import bidsReducer from './slices/bidsSlice';
import categoriesReducer from "./slices/categoriesSlice";
import eventsReducer from "./slices/eventsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    organization: organizationReducer,
    bids: bidsReducer,
    categories: categoriesReducer,
    events: eventsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;